import { RunningExperiments, useExperiments } from 'state/experiments';

export const useLiveOrderStatusTrackerEnabled = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.LiveOrderStatusTracker, 'treatment', {
    skipExposureLogging: true,
  });
};
